import "./Airpods.css";

function Airpods() {
    return (
        <section className="airpods-ultra">
            <div className="container-fluid">
                <div className="row">
                    <div className="airpods-wrapper col-md-6 left">
                        <div className="airpods cursorP">
                            <div className="airpods-logo"></div>
                            <div className="name3 mb-1">Airpods</div>
                            <div className="name4 mb-3">Share the joy.</div>
                            <div className="links-blue ps-3">
                                <a href="">Shop</a>
                            </div>
                        </div>
                    </div>
                    <div className="ultra-wrapper col-md-6 right">
                        <div className="ultra-right cursorP">
                            <div className="ultra-logo mb-2"></div>
                            <div>Adventure awaits.</div>
                            <div className="links-blue">
                                <ul className="list-inline iphoneproa">
                                    <li className="list-inline-item">
                                        <a href="">Learn more</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="">Buy</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Airpods;
